import { AxiosResponse } from 'axios'
import { http } from '@/core/realisations/Http.realisation'

import {
    GetOrderPeriodsParams,
    GetOrderPeriodsResponse
} from '@/new-services/types/order-period'

type ApiGetOrderPeriodsResponse = Promise<AxiosResponse<GetOrderPeriodsResponse>>

export function getOrderPeriods(params: GetOrderPeriodsParams): ApiGetOrderPeriodsResponse {
    return http.get('/dispatcher/api/order-period', { params })
}

export default {
    getOrderPeriods
}